import React from 'react';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../settings/variables/Colors';

interface CircularIconProps {
  onClick?: () => unknown;
  size?: number;
  backgroundColor?: keyof typeof COLORS;
  icon: IconProp | IconDefinition;
  className?: string;
}

const StyledDiv = styled.div<{
  onClick: CircularIconProps['onClick'];
  size: CircularIconProps['size'];
  backgroundColor: CircularIconProps['backgroundColor'];
}>`
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${COLORS[backgroundColor]};` : ''}
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
  border-radius: 100px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${({ size }) => `${size}px;`}
  height: ${({ size }) => `${size}px;`}
`;

const CircularIcon: React.FC<CircularIconProps> = ({
  icon,
  onClick,
  size = 32,
  backgroundColor,
  className,
}) => {
  return (
    <StyledDiv
      onClick={onClick}
      size={size}
      backgroundColor={backgroundColor}
      className={className}
    >
      <FontAwesomeIcon icon={icon} className="icon" />
    </StyledDiv>
  );
};

export default CircularIcon;
